import { Checkbox, TableCell, TableHead, TableRow } from "@mui/material"
import TableHeaderRowMonitoring from "./TableHeaderRowMonitoring";
import CreateButton from "../CreateButton";
import TableHeaderCell from "../Dynamic/TableHeaderCell";

function TableHeaderStatic({
  tableHeaders,
  entity,
  canCreate,
  numSelected,
  rowCount,
  onSelectAllClick,
  sortColumn,
  sortDirection,
  onSort,
  createAction
}) {
  return (
    <TableHead>
      <TableRow>
        {onSelectAllClick && rowCount > 0 &&
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'select all answers',
              }}
            />
          </TableCell>
        }
        {!onSort ?
          tableHeaders.map(header =>
            <TableHeaderRowMonitoring key={header} title={header} />
          )
          :
          tableHeaders.map((header) => (
            <TableHeaderCell
              key={header.id}
              column={header}
              sortColumn={sortColumn}
              sortDirection={sortDirection}
              onSort={onSort} />
          ))
        }
        <TableCell align="center">
          {canCreate && <CreateButton entity={entity} />}
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export default TableHeaderStatic